import { FROM_SETUP_STORAGE_KEY } from '../constants';

export const markChannelsFromSetup = () => {
  try {
    sessionStorage.setItem(FROM_SETUP_STORAGE_KEY, '1');
  } catch {
    // sessionStorage unavailable
  }
};

export const clearChannelsFromSetup = () => {
  try {
    sessionStorage.removeItem(FROM_SETUP_STORAGE_KEY);
  } catch {
    // sessionStorage unavailable
  }
};

export const isChannelsFromSetup = () => {
  try {
    return sessionStorage.getItem(FROM_SETUP_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};
